import {
  LOGIN_PENDING,
  LOGIN_PENDING_DETAILS,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_SIGN_IN_ERROR,
} from '../actions/index'

const initialState = {
  scope: null,
  access_token: null,
  token_type: null,
  expires_in: null,
  expires_at: null,
  refresh_token: null,
  loading: false,
  signInError: '',
  missingFields: [],
  client_id: '',
  provider: '',
  providerSecret: '',
  providerToken: '',
}

export default function session(state = initialState, action) {
  switch (action.type) {
    case LOGIN_PENDING: {
      return {
        ...state,
        scope: null,
        access_token: null,
        token_type: null,
        expires_in: null,
        expires_at: null,
        refresh_token: null,
        loading: true,
        signInError: '',
      }
    }

    case LOGIN_PENDING_DETAILS: {
      const { config, data } = action.payload
      const { client_id, provider, providerSecret, providerToken } = JSON.parse(config.data)

      return {
        ...state,
        missingFields: data.missing_fields,
        client_id,
        provider,
        providerSecret,
        providerToken,
      }
    }

    case LOGIN_SUCCESS: {
      return {
        ...state,
        scope: action.payload.data.scope,
        access_token: action.payload.data.access_token,
        token_type: action.payload.data.token_type,
        expires_in: action.payload.data.expires_in,
        expires_at: action.payload.data.expires_at,
        refresh_token: action.payload.data.refresh_token,
        loading: false,
        signInError: '',
      }
    }

    case LOGIN_FAIL: {
      return {
        ...state,
        signInError: action.payload.data.error_description,
        loading: false,
      }
    }

    case LOGOUT: {
      return {
        ...state,
        user: null,
        access_token: null,
        token_type: null,
        expires_in: null,
        expires_at: null,
        refresh_token: null,
        loading: false,
        signInError: '',
      }
    }

    case CLEAR_SIGN_IN_ERROR: {
      return {
        ...state,
        loading: false,
        signInError: '',
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.js